import { call, put } from "redux-saga/effects";

import { apiGeneral, queryBuilder, notify } from "services";
import { IPaginateRequest } from "interfaces/paginate-duck";
import { requestErrorHandler } from "utils";
import { PaginateDocumentCategoryActions } from "store/ducks/settings/document-category";

export function* paginateDocumentCategoryRequest(action: any) {
  try {
    const { query = {} } = action as IPaginateRequest;
    const queryString = queryBuilder(query);

    const { data: responseBody } = yield call(
      apiGeneral.get,
      `/document-category?${queryString}`
    );

    const { categories, pagination } = responseBody;
    yield put(PaginateDocumentCategoryActions.success(categories, pagination));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(PaginateDocumentCategoryActions.failure(errorMessage));
  }
}
